// extracted by mini-css-extract-plugin
export default {"Footer":"index_Footer__3oXh1","Content":"index_Content__3xnMl","Logo":"index_Logo__Xdjnp"};